import { ORDER_BY } from 'constants/paginationOrder';
import {
  FETCH_FAQS,
  FETCH_FAQS_FAILED,
  FETCH_FAQS_SUCCESS,
} from 'store/actions/faqs/type';

export const initialState = {
  listOfFAQs: {
    params: {
      page: 1,
      size: 10,
      orderBy: ORDER_BY.ASC,
    },
    totalPages: 1,
    totalElements: 10,
    results: {
      list: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    },
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAQS:
      return {
        ...state,
        listOfFAQs: {
          ...state.listOfFAQs,
          results: {
            ...state.listOfFAQs.results,
            loading: false,
            success: false,
            error: false,
            errorMessage: ':(',
          },
        },
      };
    case FETCH_FAQS_SUCCESS:
      return {
        ...state,
        listOfFAQs: {
          ...state.listOfFAQs,
          params: {
            ...state.listOfFAQs.params,
            ...action.payload.params,
          },
          totalPages: action.payload.totalPages || state.listOfFAQs.totalPages,
          totalElements:
            action.payload.totalElements || state.listOfFAQs.totalPages,
          results: {
            ...state.listOfFAQs.results,
            list: action.payload.incrementalList
              ? state.listOfFAQs.results.list.concat(action.payload.list)
              : action.payload.list,
            loading: false,
            success: true,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_FAQS_FAILED:
      return {
        ...state,
        listOfFAQs: {
          ...state.listOfFAQs,
          results: {
            ...state.listOfFAQs.results,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload,
          },
        },
      };

    default:
      return state;
  }
};
